import React, { useCallback, useId } from 'react'
import { FloatingLabel, Form } from 'react-bootstrap'

interface SelectProps {
    label: React.ReactNode
    options: string[] | [string, string][]
    onChange: (value: string) => Promise<void>
    value: string
    hint?: string
    required?: boolean
}

const Select: React.FC<SelectProps> = ({
    label,
    options,
    onChange,
    value,
    hint,
    required,
}) => {
    const id = useId()

    const handleChange = useCallback(
        async (event: React.ChangeEvent<HTMLSelectElement>) => {
            await onChange(event.target.value)
        },
        [onChange],
    )
    const labelClass = value ? 'nowrap-label' : ''

    return (
        <>
            {required && <span className="error">*</span>}

            <FloatingLabel
                className="mb-3 w-100"
                controlId={id}
                label={<span className={labelClass}>{label}</span>}
            >
                <Form.Select value={value || ''} onChange={handleChange}>
                    <option key="" value="" />
                    {options.map(option => {
                        if (Array.isArray(option)) {
                            return (
                                <option key={option[1]} value={option[1]}>
                                    {option[0]}
                                </option>
                            )
                        } else {
                            return (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            )
                        }
                    })}
                </Form.Select>

                {hint && <Form.Text>{hint}</Form.Text>}
            </FloatingLabel>
        </>
    )
}

export default Select
